<template>
  <b-container>
    <!-- {{model}} -->
    <!-- VehicleTypeActive -->
    <b-form-group :label="$t('geral.active')" label-for="vehicleTypeActive">
      <b-form-select
        id="vehicleTypeActive"
        :options="optionsBoolean"
        v-model="model.vehicleTypeActive"
        :disabled="true"
      >
      </b-form-select>
      <span class="text-danger" v-if="modelstate['VehicleTypeActive']">
        {{ modelstate["VehicleTypeActive"][0] }}
      </span>
    </b-form-group>

    <!-- VehicleTypeName -->
    <b-form-group
      :label="$t('tracking.vehicleType.name')"
      label-for="vehicleTypeName"
    >
      <b-form-input
        id="vehicleTypeName"
        type="text"
        placeholder="Informe o nome de exibição"
        v-model="model.vehicleTypeName"
        :readonly="readonly"
        required
      />
      <span class="text-danger" v-if="modelstate['Name']">
        {{ modelstate["Name"][0] }}
      </span>
    </b-form-group>

    <!-- VehicleTypeDescription -->
    <b-form-group
      :label="$t('tracking.vehicleType.description')"
      label-for="vehicleTypeDescription"
    >
      <b-form-input
        id="vehicleTypeDescription"
        type="text"
        placeholder="Informe a descrição de exibição"
        v-model="model.vehicleTypeDescription"
        :readonly="readonly"
        required
      />
      <span class="text-danger" v-if="modelstate['VehicleTypeDescription']">
        {{ modelstate["VehicleTypeDescription"][0] }}
      </span>
    </b-form-group>

    <!-- {{ model }} -->
  </b-container>
</template>

<script>
export default {
  name: "VehicleTypeCrudData",
  props: {
    model: Object,
    modelstate: Array,
    readonly: Boolean
  },
  data() {
    return {
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" }
      ]
    };
  }
};
</script>
